import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DropsService } from '../_services/drops.service';

@Component({
  selector: 'app-drops-dialog',
  templateUrl: './drops-dialog.component.html',
  styles: [
    `
      .selections {
        overflow: auto;
      }
      .selections-loading {
        display: flex;
        justify-content: center;
        padding: 24px 0;
      }
      table {
        width: 100%;
        border-collapse: collapse;
      }
      th,
      td {
        text-align: left;
        padding: 6px 8px;
        white-space: nowrap;
        border-bottom: 1px solid #e8e8e8;
      }
      .dialog-error {
        color: #b00020;
      }
    `,
  ],
})
export class DropsDialogComponent implements OnInit {
  loading = false;
  error = '';
  selections: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<DropsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dropsService: DropsService
  ) {}

  ngOnInit(): void {
    if (this.data.mode !== 'selections') return;
    this.loading = true;
    this.dropsService.selections(this.data.drop.id).subscribe(
      (result) => {
        this.selections = result.selections || [];
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = 'Could not load members who selected this drop.';
      }
    );
  }

  close(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }

  classLabel(value: string): string {
    if (!value) return '';
    return value
      .split('_')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }
}
